import HandleResponses from '@common/utils/handleApiResponsesV2';
import axios from '../../../axios';

const actions = {
  async getDashboardDetails(_, data) {
    try {
      const result = await axios.get(`/dashboard/${data.section}`, { params: data.params });
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async filter({ commit }, filters) {
    try {
      let result = [];
      if (filters.page === 1) {
        commit('SET_LOADING', true);
      } else {
        commit('paginationCheck', true);
      }
      const params = filters;
      result = await axios('/track-trip', { params });

      if (result && result.data) {
        commit('SET_LIST', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('SET_LOADING', false);
    }
  },
  async rejectionFilter({ commit }, filters) {
    try {
      let result = [];
      if (filters.page === 1) {
        commit('SET_LOADING', true);
      } else {
        commit('paginationCheck', true);
      }
      const params = filters;
      result = await axios('/track-trip-rejections', { params });

      if (result && result.data) {
        commit('SET_REJECTED_LIST', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('SET_LOADING', false);
    }
  },
  async getTripDetails({ commit }, data) {
    try {
      commit('SET_LOADING', true);
      const safeToken = data.t && /^[A-Za-z0-9+/=]+$/.test(data.t) ? data.t : null;
      const url = data.isOpenLink ? `/ol-track-trip/${safeToken || data.id}` : `/track-trip/${data.id}`;
      const result = await axios.get(url);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getShipmentTrackLocations(_, data) {
    try {
      const safeToken = data.t && /^[A-Za-z0-9+/=]+$/.test(data.t) ? data.t : null;
      const url = data.isOpenLink ? `/ol-track-trip-cordinates/${safeToken || data.id}` : `/track-trip-cordinates/${data.id}`;
      const params = {};
      if (data.consigneeId) params.consigneeId = data.consigneeId;
      if (data.bookingId) params.bookingId = data.bookingId;
      const result = await axios.get(url, { params });
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } 
  },
  async getConsigneeTripDetails({ commit }, data) {
    try {
      commit('SET_LOADING', true);
      const result = await axios.get(`/track/${data.orderNo}`,
        { params: { id: data.consigneeId, bookingId: data.bookingId } });
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async transporterList({ commit }) {
    try {
      commit('SET_TRANSPORTER_LOADING', true);
      const result = await axios.get('/carrier');
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('SET_TRANSPORTER_LOADING', false);
    }
  },
  async getActiveTrips() {
    try {
      const result = await axios.get('/activeTrips');
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async export(_, filter) {
    try {
      const params = filter;
      const result = await axios.get('/exportTrips', { params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async reCaptchaVerify(_, reCaptchaVerify) {
    const result = await axios.post('/verify-captcha', { token: reCaptchaVerify });
    return result;
  },
};
export default actions;
